import React from 'react'
import { CiLinkedin } from 'react-icons/ci';
import { AiFillGithub } from 'react-icons/ai'
import { AiFillTwitterCircle } from 'react-icons/ai'
const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://linkedin.com"><CiLinkedin></CiLinkedin></a>
      <a href="https://github.com/Domains18"> <AiFillGithub></AiFillGithub></a>
      <a href="https://twitter.com/eigtsville"><AiFillTwitterCircle></AiFillTwitterCircle></a>
    </div>
  )
}

export default HeaderSocials
